import { SocialProvider } from 'modules/authentication/helpers/nativeSocialAuth';

export const AUTH_DOMAINS = [
  'https://test.withlocals.com',
  'https://www.withlocals.com',
  'https://withlocals.com',
  URL_AUTHENTICATION_HOST,
];

export const SOCIAL_PROVIDERS: SocialProvider[] = [
  'google',
  'facebook',
  'apple',
];
